import { render, staticRenderFns } from "./ConfirmClearCustomer.vue?vue&type=template&id=1272d576&scoped=true&"
import script from "./ConfirmClearCustomer.vue?vue&type=script&lang=ts&"
export * from "./ConfirmClearCustomer.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmClearCustomer.vue?vue&type=style&index=0&id=1272d576&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1272d576",
  null
  
)

export default component.exports